import styles from './TextStack.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';

import { Topic } from 'src/api/contentful/contentTypes.cloverdotcom';

import { ContentLink } from '../ContentLink/ContentLink';
import { Blurb } from '../Contentful/Blurb';
import { Text } from '../Contentful/Text';
import { applyEntryDataAttributes } from '../EntryWrapper/EntryDataWrapper';
import { MaterialIcon } from '../MaterialIcon/MaterialIcon';

export interface ITextStackProps<E extends HTMLElement = HTMLDivElement> extends React.AllHTMLAttributes<E> {
  entry?: ReferencedEntry<Topic>;
  tagName?: keyof React.ReactHTML;
  titleTagName?: keyof React.ReactHTML;
  titleClassName?: string;
  blurbClassName?: string;
  linkClassName?: string;
  showLinkArrow?: boolean;
  innerRef?: React.Ref<E>;
  forceLinkAsSpan?: boolean;
}

const TextStack: React.FC<ITextStackProps<HTMLDivElement>> = ({
  entry,
  tagName,
  titleTagName,
  titleClassName,
  blurbClassName,
  linkClassName,
  showLinkArrow,
  innerRef,
  forceLinkAsSpan,
  ...props
}) => {
  if (!entry || !entry.fields) return null;

  const { link } = entry.fields;

  const arrow = showLinkArrow && <div className={styles.linkArrow}><MaterialIcon icon="keyboard_arrow_right" /></div>;

  return React.createElement(
    tagName || 'div',
    { ...props, ref: innerRef },
    (
      <>
        <Text tagName={titleTagName || 'h2'} entry={entry} field="title" className={titleClassName} />
        <Blurb entry={entry} field="blurb" className={cx(styles.blurb, blurbClassName)} />
        {forceLinkAsSpan ? (
          <Text entry={link} field="title" className={linkClassName}>{arrow}</Text>
        ) : (
          <ContentLink entry={link} className={linkClassName}>{arrow}</ContentLink>
        )}
      </>
    )
  );
};

const Wrapped = applyEntryDataAttributes(TextStack);
export { Wrapped as TextStack };
